import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function UserMenu() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const name = localStorage.getItem("name") || "User";
  const email = localStorage.getItem("email") || "";
  const role = localStorage.getItem("role") || "viewer";
  const initials = name.split(" ").map((n: string) => n[0]).join("").toUpperCase();

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to log out?")) {
      localStorage.clear();
      navigate("/login");
    }
  };

  const roleBadge = (r: string) => {
    if (r === "super_admin") return "bg-purple-50 text-purple-700 border border-purple-200";
    if (r === "admin") return "bg-red-50 text-red-600 border border-red-200";
    if (r === "editor") return "bg-blue-50 text-blue-600 border border-blue-200";
    return "bg-gray-100 text-gray-600 border border-gray-200";
  };

  const roleLabel = (r: string) => {
    if (r === "super_admin") return "Super Admin";
    if (r === "admin") return "Admin";
    if (r === "editor") return "Editor";
    return "Viewer";
  };

  return (
    <div className="relative" ref={ref}>
      <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer"
        onClick={() => setOpen(o => !o)}>
        <span className="text-white font-medium text-xs">{initials}</span>
      </div>
      {open && (
        <div className="absolute right-0 top-10 w-56 bg-white border border-gray-200 rounded-xl shadow-lg z-50 overflow-hidden">
          <div className="px-4 py-3 border-b border-gray-100">
            <p className="text-sm font-semibold text-gray-900">{name}</p>
            {email && <p className="text-xs text-gray-400">{email}</p>}
            <span className={`inline-block mt-1.5 text-[10px] px-2 py-0.5 rounded-full font-medium ${roleBadge(role)}`}>
              {roleLabel(role)}
            </span>
          </div>
          <button onClick={handleLogout}
            className="w-full text-left px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 transition-colors flex items-center gap-2">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            Log out
          </button>
        </div>
      )}
    </div>
  );
}
